"use strict";

var _typeof2 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.checkForSatelliteAndInitialize = checkForSatelliteAndInitialize, exports.directCall = directCall, exports.dtmLoaded = dtmLoaded, exports.getSCVisitorId = getSCVisitorId, exports.sharedCall = sharedCall, exports.track = track;
var _new_relic_helper = require("./new_relic_helper"),
  _defaultFrontendVariables = require("../../../constants/defaultFrontendVariables");
function _typeof(e) {
  return (_typeof = "function" == typeof Symbol && "symbol" == _typeof2(Symbol.iterator) ? function (e) {
    return _typeof2(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof2(e);
  })(e);
}
function dtmLoaded() {
  if ("undefined" != typeof window) try {
    window._satellite.setVar("app-name", _defaultFrontendVariables.APP_NAME), window._satellite.setVar("app-version", _defaultFrontendVariables.APP_VERSION);
  } catch (e) {
    var t = "Error firing DTM loaded: ".concat(e);
    (0, _new_relic_helper.newRelicJSError)(t), console.error(t);
  }
}
function directCall(t) {
  var r = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
  if ("undefined" != typeof window) try {
    if ("object" !== _typeof(r)) return void console.error("dataElements needs to be an object.");
    window._satellite.setVar("app-name", _defaultFrontendVariables.APP_NAME), window._satellite.setVar("app-version", _defaultFrontendVariables.APP_VERSION), Object.keys(r).forEach(function (e) {
      window._satellite.setVar(e, r[e]);
    }), window._satellite.track(t);
  } catch (e) {
    t = "Error firing DTM Direct Call Rule: ".concat(e);
    (0, _new_relic_helper.newRelicJSError)(t), console.error(t);
  }
}
function sharedCall(e, t) {
  directCall("shared-call", {
    "action-type": t,
    "action-keys": e,
    "action-values": 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : "Completed"
  });
}
function checkForSatelliteAndInitialize(t, e) {
  if ("undefined" != typeof window) try {
    var r = 0,
      o = setInterval(function () {
        void 0 !== window._satellite && (dtmLoaded(), clearInterval(o)), e < r && clearInterval(o), r += 1;
      }, t);
  } catch (e) {
    t = "Error checking for _satellite: ".concat(e);
    (0, _new_relic_helper.newRelicJSError)(t), console.error(t);
  }
}
function getSCVisitorId() {
  return "undefined" == typeof window ? "" : ((e = window._satellite ? window._satellite.getVisitorId() : e) || (t = document.cookie.replace(/(?:(?:^|.*;\s*)s_vi\s*=\s*([^;]*).*$)|^.*$/, "$1").match(/(?!.*(\|)).*(?=(\[.*))/)) && 0 < t.length && (e = t.shift()), e || "");
  var e, t;
}
function track(e, t, r) {
  directCall("shared-call", {
    "action-type": t,
    "action-keys": e,
    "action-values": r || "Completed"
  });
}